import { css } from '@emotion/core';
import { variables as vars, tokens } from '@domain-group/fe-brary';
var font = vars.font;
var colors = tokens.colors;
export var propertyAlertButton = _ref2 => {
  var hasBorder = _ref2.hasBorder;
  return /*#__PURE__*/css("display:inline-flex;white-space:nowrap;color:", colors.neutral.heavy.default, ";font-size:", font.smallFontSize, ";font-weight:", font.headingFontWeight, ";text-decoration:none;height:32px;line-height:28px;", hasBorder && /*#__PURE__*/css("border:1px solid ", colors.neutral.heavy.default, ";border-radius:3px;padding:0 4px;"), " &:hover{background:", colors.neutral.subdued.default, ";}&:focus{outline:none;}.domain-icon{width:20px;height:20px;align-self:center;}");
};
var _ref = {
  name: "8yayul",
  styles: "@media (max-width:680px){display:none;}"
};
export var text = _ref3 => {
  var isResponsive = _ref3.isResponsive;
  return /*#__PURE__*/css("margin:0 4px;font-size:", font.smallFontSize, ";font-weight:", font.headingFontWeight, ";", isResponsive && _ref);
};
export var link = /*#__PURE__*/css("display:inline-block;font-size:", font.baseFontSize, ";text-decoration:underline;color:", colors.neutral.heavy.default, ";background:none;border:0;outline:0;cursor:pointer;padding:0;");